<template>
  <v-layout class="request-list-detail">
    <template v-for="(list, index) in lists">
      <v-flex :key="list.id" v-if="showAll(index)">
          <div class="report">
            <a :href="list.crlLink" class="btn-tertiary list-link">{{list.title}}</a>
            <div class="actions">
              <button type="button" @click="copy(list.id)" class="btn-tertiary copy">Copy</button>
              <a :href="list.emailLink" class="btn-tertiary email">Email</a>
              <a :href="list.downloadLink" class="btn-tertiary download">Download</a>
            </div>
          </div>

          <div class="details">
            <p v-if="list.updatedBy">
              Updated by {{list.updatedBy}} on
              {{getLastUpdated(list.lastUpdated)}}
            </p>
            <div class="status">
              <div>Accepted <span>{{list.accepted}}</span></div>
              <div>Requested <span>{{list.requested}}</span></div>
            </div>
          </div>

          <div v-if="showWarning(index, hgRequestLists.newInspectionLink)" class="new-inspection">
            <a :href="hgRequestLists.newInspectionLink">New Inspection Report Available</a>
          </div>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import Moment from 'moment';

export default {
  props: {
    hgRequestLists: {
      type: Object,
      required: true,
    },
    hgShowAll: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    getLastUpdated(lastUpdatedDate) {
      return lastUpdatedDate
        ? Moment(lastUpdatedDate).format('MMM D, YYYY')
        : '';
    },
    showWarning(index, link) {
      return index === 0 && link;
    },
    showAll(index) {
      return index === 0 || this.hgShowAll === true;
    },
    copy(crlId) {
      this.$emit('copy', crlId);
    },
  },
  computed: {
    lists() {
      return this.hgRequestLists.lists;
    },
  },
};
</script>


<style lang="scss" scoped>
@import '../../../styles/vars/icons';
@import '../../../styles/vars/theme';
@import '../../../styles/vars/typography';

@mixin iconBackground($icon-url) {
  background: transparent $icon-url scroll no-repeat left center;
}

.email {
  @include iconBackground($icon-image-mail);
}

.download {
  @include iconBackground($icon-image-download);
}

.copy {
  @include iconBackground($icon-image-copy);
}

.copy,
.download,
.email {
  text-decoration: none;
  font-size: 1rem;
  font-weight: $typography-weight-bold;
  padding-left: 25px;
  text-transform: none;
}

.download,
.email {
  margin-left: 30px;
}

.new-inspection a {
  @include iconBackground($icon-image-warning);
  color: $theme-color-alert;
  padding-left: 20px;
  text-decoration: underline;
}


.list-link {
  @include iconBackground($icon-image-file);
  font-size: 1.214rem;
  padding-left: 25px;
}

.request-list-detail {
  flex-direction: column;

  .flex {
    border-bottom: solid 1px rgba(0, 0, 0, 0.15);
    margin-top: 10px;
    padding-bottom: 20px;

    &:last-child {
      border-bottom: none
    }
  }
}

.report {
  margin-top: 20px;
}

.actions,
.status {
  display: flex;
}

.status {
  div {
    border-right: solid 1px rgba(0, 0, 0, 0.15);
    padding-left: 20px;
    padding-right: 20px;

    &:last-child {
      border-right: none;
      padding-right: 0;
    }
  }

  span {
    font-weight: $typography-weight-bold;
    margin-left: 5px;
  }
}

.details,
.new-inspection,
.report {
  display: flex;
  justify-content: space-between;
}

.details p,
.status div {
  margin-bottom: 6px;
  margin-top: 6px;
}

.details {
  color: rgba(0, 0, 0, 0.6);
  font-size: 0.857rem;
}

@media all and (max-width: 800px) {
  .details,
  .new-inspection,
  .report {
    align-items: center;
    flex-direction: column;
  }

  .report {
    margin-top: 30px;
  }

  .status {
    align-items: center;
    flex-direction: column;
    padding-top: 10px;

    div {
      border-right: none;
      margin: 0 0 5px;
      padding: 0;
    }
  }

  .actions {
    margin-top: 30px;
  }

  .details {
    border-top: solid 1px rgba(0, 0, 0, 0.15);
    margin-top: 20px;
    padding-top: 20px;
  }

  .request-list-detail .flex {
    border-bottom: solid 3px rgba(0, 0, 0, 0.2);
  }

  .new-inspection {
    margin-bottom: 20px;
    margin-top: 20px;
  }
}
</style>
